module.exports = __webpack_public_path__ + "img/Responsible Citizen.f1bd31e0.png";